/* eslint-disable no-unused-vars */
import { useId, useMemo, memo } from 'react';
import styled from 'styled-components';
import { CustomInput, Label } from 'components';
import { LengthCounter } from '../index';
import { useSelector } from 'react-redux';
import { getCreativeMessage } from 'store/selectors';
import { useSignal } from '@preact/signals-react';

const MAX_SIZE = 90;

export const Message = memo(({ onChangeParam }) => {
  const inputId = useId();

  const { fieldName, messageValue } = useSelector(getCreativeMessage);

  const isError = useMemo(() => messageValue?.length < 2, [messageValue]);

  const maxCharsError$ = useSignal(false);

  const getErrorMsg = () => {
    if (maxCharsError$.value) {
      return `Text exceeds the ${MAX_SIZE}-character limit. Please shorten your input and try again.`;
    }
    return 'Please Insert Creative message';
  };

  return (
    <Container>
      <LabelBox>
        <Label text='Message:' variant='label' />
        <LengthCounter maxSize={MAX_SIZE} str={messageValue} />
      </LabelBox>
      <CustomInput
        onBlur={() => {}}
        value={messageValue}
        autoComplete='off'
        id={inputId}
        name={inputId}
        onChange={(e) => {
          maxCharsError$.value = e.target.value.length > MAX_SIZE;
          onChangeParam(e, fieldName, MAX_SIZE);
        }}
        placeholder='Creative message'
        error={isError || maxCharsError$.value}
        errorText={getErrorMsg()}
        inputStyle={{
          borderTopRightRadius: '0',
          borderBottomRightRadius: '0',
          minHeight: '48px',
        }}
      />
    </Container>
  );
});

const Container = styled.div`
  margin-top: 16px;
`;

const LabelBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

Message.displayName = 'Message';
